import { Component, Input,ViewChild, ElementRef,Output,EventEmitter } from '@angular/core';
import { NgbModal,NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FileService } from '../../../api/file.service'
import { HelperService,ErrorClass } from '../../../api/helper.service'

@Component({
    selector: 'file-modal',
    template: `
    <div class="modal-header">
        <h4 class="modal-title">File Manager</h4>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
            <h1 mat-dialog-title>Upload Image</h1>
            <input #file_upload type="file" id="avatar" name="avatar" 
          [(ngModel)]="newfile"
          (change)="onFileSelected($event)">
          <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
            <div class="row">
                <div class="col-sm-4" *ngFor="let r of fileList">
                   {{r.id}}
                   <img src="{{r.img_url}}" height="200px" width="250px" />
                   <button class="btn btn-primary" (click)="sel(r.img_url)">Select File</button> 
                </div>
            </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
      </div>
    `
  })
  
  export class FileModal {
    @Input() partner_id;

    @ViewChild('modal') modal: ElementRef;

    @Output() onCreated: EventEmitter<string> = new EventEmitter<string>();

    fileList: FileClass[] = [];

    newfile:any
    loading = false
    public open(){
        //alert('Working partner Segment:' + this.partner_id)
        // const modRef = this.modalService.open(this.modal);
        // modRef.componentInstance.name = 'Vin';
    }
    fileSelected:any 
  public avatar;
    
  onFileSelected(event){
    if(event.target.files.length > 0) 
    {
      this.fileSelected = event.target.files[0] 
      this.uploadAvatar(this.fileSelected)
      //Upload File 
    }
  }

  uploadAvatar(file:any){
    this.loading = true
      this.fileAPI.uploadFile(file).subscribe(
      (data) => {
         this.loading =false
         this.loadFiles()
      },
      (err:ErrorClass) => {
        this.help.msgboxError("Error", err.error_message);
         this.loading = false
      }
    )
    
  }


    sel(img){
       this.activeModal.close(img)
    }
    ngOnInit(){
      this.loadFiles()
    }
    constructor(
      public modalService:NgbModal,
      public activeModal:NgbActiveModal,
      private fileAPI:FileService,
      private help:HelperService,
      ) {}

      loadFiles(){
         this.fileAPI.getFiles().subscribe(
           (data:FileClass[]) => {
              this.fileList = data
           }
         )
      }
  }

  class FileClass {
    id:number;
    img_url:string;
  }